import { useMemo } from 'react';

import { create } from 'zustand';

import { createDoBoxDelegateComposerSlice } from './actions';
import { DEFAULT_COMPOSER_ENTRY_STATE } from './handlers';
import {
  DoBoxDelegateComposerEntryState,
  DoBoxDelegateComposerStore,
} from './types';

export const useDoBoxDelegateComposerStore =
  create<DoBoxDelegateComposerStore>()((set, get, store) => ({
    ...createDoBoxDelegateComposerSlice(set, get, store),
  }));

/** An entry with no explicit state defaults to the agent last used on that task, else the
 *  last agent the owner picked anywhere, else the assistant. */
export const useDoBoxDelegateComposerEntry = (
  entryId: string,
): DoBoxDelegateComposerEntryState => {
  const stored = useDoBoxDelegateComposerStore(
    (state) => state.stateByEntryId[entryId],
  );
  const preferredAgent = useDoBoxDelegateComposerStore(
    (state) => state.lastAgentByEntryId[entryId] ?? state.lastAgent,
  );
  return useMemo(() => {
    if (stored) {
      return stored;
    }
    return preferredAgent
      ? { ...DEFAULT_COMPOSER_ENTRY_STATE, target: preferredAgent }
      : DEFAULT_COMPOSER_ENTRY_STATE;
  }, [stored, preferredAgent]);
};
